import * as Sentry from '@sentry/react'

import { ENV, IS_PROD, SENTRY_DSN } from '@/env'

Sentry.init({
  enabled: IS_PROD && !!SENTRY_DSN,
  dsn: SENTRY_DSN,
  debug: false,
  environment: ENV,
  ignoreErrors: [`Network request failed`],
  attachStacktrace: false, // does not affect traces of errors or other logs.
  integrations: [
    Sentry.feedbackIntegration({
      autoInject: false,
      id: 'sentry-feedback',
      colorScheme: 'light',
      showBranding: false,
      triggerLabel: 'Feedback',
      formTitle: 'Votre avis nous intéresse',
      showName: false,
      submitButtonLabel: 'Envoyer',
      cancelButtonLabel: 'Annuler',
      confirmButtonLabel: 'OK',
      addScreenshotButtonLabel: 'Ajouter une capture d’écran',
      removeScreenshotButtonLabel: 'Supprimer la capture d’écran',
      emailLabel: 'Votre email (optionnel)',
      emailPlaceholder: 'exemple@domaine.com',
      isRequiredLabel: '(requis)',
      messageLabel: 'Votre message',
      messagePlaceholder: 'Décrivez votre problème ou suggestion ici...',
      successMessageText: 'Merci pour votre retour !',
      highlightToolText: 'Surligner',
      hideToolText: 'Masquer',
      removeHighlightText: 'Supprimer le surlignage',
    }),
    Sentry.replayIntegration,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
